import LaunchSharpIcon from "@mui/icons-material/LaunchSharp";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import React from "react";

interface ExternalLinkButtonProps {
  url: string;
  text: React.ReactNode;
  theme: any;
  primaryTypographyProps?: object;
}

const ExternalLinkButton: React.FC<ExternalLinkButtonProps> = ({
  url,
  text,
  theme,
  primaryTypographyProps,
}) => (
  <ListItemButton
    sx={{
      pl: 5,
      width: "220px",
      height: "40px",
    }}
    onClick={() => window.open(url, "_blank", "noopener")}
  >
    <ListItemText
      primary={text}
      primaryTypographyProps={{
        fontSize: "14px",
        fontWeight: 400,
        color: theme.tokens.FuelColorTextHeading,
        whiteSpace: "nowrap",
        ...primaryTypographyProps,
      }}
    />
    <ListItemIcon sx={{ pr: "4px", minWidth: "0" }}>
      <LaunchSharpIcon
        sx={{
          color: theme.tokens.FuelColorTextIcon,
          width: "24px",
        }}
      />
    </ListItemIcon>
  </ListItemButton>
);

export default ExternalLinkButton;
